export class Config {
  constructor(public gateway: string) {}
}
